import React from 'react'
import { useI18n } from '../../i18n'
import type { ExecutionProgress } from '../../services/complianceExecutionApi'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

interface Props {
  stage?: string | null
  progress?: ExecutionProgress | null
  blockerCount?: number
}

export default function ExecutionProgressStrip({ stage, progress, blockerCount = 0 }: Props) {
  const { t } = useI18n()
  if (!stage && !progress) return null
  return (
    <div className={wfStyles.progressStrip} role="status">
      {stage ? (
        <span className={wfStyles.stageBadge}>
          {t('complianceExecution.currentStage', 'Current stage')}: {stage.replace(/_/g, ' ')}
        </span>
      ) : null}
      {progress?.controlsSatisfiedLabel ? (
        <span className={wfStyles.itemMeta}>
          {t('complianceExecution.progress.controls', 'Progress')}: {progress.controlsSatisfiedLabel}{' '}
          {t('complianceExecution.progress.satisfied', 'controls satisfied')}
        </span>
      ) : null}
      {blockerCount > 0 ? (
        <span className={wfStyles.itemMeta}>
          {t('complianceExecution.openBlockers', 'Open blockers')}: {blockerCount}
        </span>
      ) : null}
      {progress?.assessmentPercent != null ? (
        <span className={wfStyles.itemMeta}>
          {t('complianceExecution.assessmentProgress', 'Assessments')}: {progress.assessmentPercent}%
        </span>
      ) : null}
    </div>
  )
}
